import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { PatientNote } from '../../models/patient-note';

@Injectable({
  providedIn: 'root',
})
export class PatientNotesService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  endpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientNotes`;

  postPatientNotes(patientId: number, pageNumber: number, pageSize: number): Observable<PatientNote[]> {
    const body = {
      pageNumber,
      pageSize,
    };
    // List read: ReportsComponent renders app-error-state with a retry.
    return this.utilityService.postRequest<PatientNote[]>(`${this.endpoint}?patientId=${patientId}`, body, {
      skipGlobalError: true,
      applyDefaultTimeout: true,
    });
  }

  getPatientNote(patientNoteId: number, patientId: number): Observable<PatientNote> {
    const url = `${this.endpoint}/${patientNoteId}?patientId=${patientId}`;
    // Preview read. Opting out is what makes the preview's local error pane reachable at all: without
    // it ErrorInterceptor navigates to /error before loadDesktopPreview's catch can set
    // previewState='error', so the treatment PBI 54130 chose could never actually be seen.
    return this.utilityService.getRequest<PatientNote>(url, { skipGlobalError: true });
  }

  postPrintEvent(patientId: number, patientNoteId: number): Observable<void> {
    const url = `${this.endpoint}/${patientNoteId}/PrintEvent?patientId=${patientId}`;
    return this.utilityService.postRequest<void>(url, null, { skipGlobalError: true });
  }
}
